import { Link } from "react-router-dom";
import { MapPin, Calendar } from "lucide-react";
import UrgencyBadge from "../common/UrgencyBadge";
import UserChip from "../common/UserChip";
import CpBadge from "../social/CpBadge";
import { CATEGORY_LABELS } from "../../lib/constants";

export default function PostCard({ post }) {
  const dateRange = post.needed_by_end
    ? `${post.needed_by_start} - ${post.needed_by_end}`
    : post.needed_by_start;

  return (
    <Link
      to={`/posts/${post.id}`}
      className="block bg-cream rounded-lg shadow-card hover:shadow-card-hover transition-shadow p-4"
    >
      <div className="flex items-center gap-2 mb-2">
        <UrgencyBadge urgency={post.urgency} />
        <span className="text-xs text-walnut-light">{CATEGORY_LABELS[post.category]}</span>
        <span className="text-xs text-walnut-light/60 ml-auto capitalize">{post.type}</span>
      </div>
      <h3 className="font-display font-semibold text-walnut text-lg mb-2 line-clamp-2">
        {post.title}
      </h3>
      {post.author && (
        <div className="mb-3">
          <UserChip user={post.author} link={false} />
        </div>
      )}
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-walnut-light">
        {post.distance_km != null && (
          <span className="inline-flex items-center gap-1">
            <MapPin size={12} />
            {post.distance_km.toFixed(1)} km away
          </span>
        )}
        <span className="inline-flex items-center gap-1">
          <Calendar size={12} />
          {dateRange}
        </span>
        <CpBadge min={post.cp_estimate_min} max={post.cp_estimate_max} />
      </div>
      {post.takers_needed != null && (
        <p className="text-xs text-walnut-light mt-2">
          {post.takers_filled} of {post.takers_needed} spots filled
        </p>
      )}
    </Link>
  );
}
